import { createSlice } from "@reduxjs/toolkit";

import { type AudioPlayerState } from "./types";

const initialState: AudioPlayerState = {
  isPlaying: false,
  played: 0,
  duration: 0,
  currentTime: "00:00.000",
  totalTime: "00:00.000",
  seeking: false,
};

const audioPlayer = createSlice({
  name: "audioPlayer",
  initialState,
  reducers: {
    setIsPlaying(state, action) {
      return { ...state, isPlaying: action.payload };
    },
    setPlayed(state, action) {
      return { ...state, played: action.payload };
    },
    setDuration(state, action) {
      return { ...state, duration: action.payload };
    },
    setCurrentTime(state, action) {
      return { ...state, currentTime: action.payload };
    },
    setTotalTime(state, action) {
      return { ...state, totalTime: action.payload };
    },
    setSeeking(state, action) {
      return { ...state, seeking: action.payload };
    },
  },
});

export const {
  setIsPlaying,
  setPlayed,
  setDuration,
  setCurrentTime,
  setTotalTime,
  setSeeking,
} = audioPlayer.actions;
export const { reducer: audioPlayerReducer } = audioPlayer;
